import { Attribution, SortBy, SortType } from 'types'

interface Params {
  endDate: string
  startDate: string
  limit: number
  offset: number
  attr: Attribution
  id: string
  sortBy?: SortBy
  sortType?: SortType
}

export const getWebsitesTableData = ({
  endDate,
  startDate,
  limit,
  offset,
  attr,
  id,
  sortBy,
  sortType,
}: Params) => {
  let sortParamName

  if (sortBy === 'views') {
    sortParamName = `stats.${sortBy}`
  } else if (attr === 'first' || attr === 'last') {
    sortParamName = `${attr}.${sortBy}`
  } else if (attr === 'linear' || attr === 'ai') {
    sortParamName = `${attr}_page.${sortBy}`
  }

  const sorting = sortBy ? `ORDER BY ${sortParamName} ${sortType}` : ''

  switch (attr) {
    case 'first':
      return `SELECT SUM(stats.views), SUM(first.leads), SUM(first.form_submits), SUM(first.total_orders), SUM(first.total_amount), SUM(first.recurring_payments_amount), SUM(first.orders_amount), page.href, page.page_id FROM page WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' AND stats.website_id = '${id}' GROUP BY page.href, page.page_id ${sorting} LIMIT ${limit} OFFSET ${offset}`
    case 'last':
      return `SELECT SUM(stats.views), SUM(last.leads), SUM(last.form_submits), SUM(last.total_orders), SUM(last.total_amount), SUM(last.recurring_payments_amount), SUM(last.orders_amount), page.href, page.page_id FROM page WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' AND stats.website_id = '${id}' GROUP BY page.href, page.page_id ${sorting} LIMIT ${limit} OFFSET ${offset}`
    case 'linear':
      return `SELECT SUM(stats.views), SUM(linear_page.leads), SUM(linear_page.form_submits), SUM(linear_page.total_orders), SUM(linear_page.total_amount), SUM(linear_page.recurring_payments_amount), SUM(linear_page.orders_amount), page.href, page.page_id FROM page WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' AND stats.website_id = '${id}' GROUP BY page.href, page.page_id ${sorting} LIMIT ${limit} OFFSET ${offset}`
    case 'ai':
      return `SELECT SUM(stats.views), SUM(ai_page.leads), SUM(ai_page.form_submits), SUM(ai_page.total_orders), SUM(ai_page.total_amount), SUM(ai_page.recurring_payments_amount), SUM(ai_page.orders_amount), page.href, page.page_id FROM page WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' AND stats.website_id = '${id}' GROUP BY page.href, page.page_id ${sorting} LIMIT ${limit} OFFSET ${offset}`
    default:
      return ''
  }
}
